import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocaleComponent } from './components/locale/locale.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UiComponentsModule } from 'az-customer-portal-ui';
import { SemiBoldPipe } from '@shared/pipes/semibold.pipe';
import { CustomAnchorPipe } from '@shared/pipes/custom-anchor.pipe';
import { DateFormatPipe } from '@shared/pipes/date-format.pipe';
import { StepFormService } from '../step-form/services/step-form.service';
import { LocaleService } from './services/locale.service';
import { Title } from '@angular/platform-browser';
import { EnvironmentInterface } from '@core/interface/environment.interface';

@NgModule({
    declarations: [
        LocaleComponent,
        SemiBoldPipe,
        CustomAnchorPipe,
        DateFormatPipe
    ],
    imports: [
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (http: HttpClient, stepFormService: StepFormService) => {
                    return new TranslateHttpLoader(http, stepFormService.deployUrl + 'assets/i18n/', '.json')
                },
                deps: [HttpClient, StepFormService]
            }
        }),
        UiComponentsModule
    ],
    exports: [
        LocaleComponent,
        TranslateModule,
        SemiBoldPipe,
        CustomAnchorPipe,
        DateFormatPipe
    ]
})
export class LocaleModule {

    static forChild(environment: EnvironmentInterface): ModuleWithProviders<LocaleModule> {
        return {
            ngModule: LocaleModule,
            providers: [
                {
                    provide: LocaleService,
                    useFactory: (translateService: TranslateService, stepFormService: StepFormService, title: Title) => {
                        return new LocaleService(environment, translateService, stepFormService, title)
                    },
                    deps: [TranslateService, StepFormService, Title]
                }
            ]
        };
    }
}